/**
 * A marca no cabeçalho.
 *
 * Existe como componente próprio para haver um lugar só a trocar quando a
 * logo chegar. Estava solta dentro do cabeçalho, e trocar arte espalhada
 * pelo JSX é como uma versão fica para trás.
 *
 * A logo é só símbolo, sem a palavra desenhada, então o nome continua em
 * texto ao lado. Um símbolo sozinho no topo deixaria o site sem se
 * apresentar, e "VersusPlay" escrito também é o que busca e leitor de
 * tela leem.
 *
 * `aria-hidden` na imagem, e o nome no texto: sem isso o leitor de tela
 * anunciaria a marca duas vezes.
 */
export function Marca() {
  return (
    <span
      className="flex items-center gap-2 font-bold tracking-tight"
      aria-label="VersusPlay"
    >
      <img
        src="/marca.svg"
        alt=""
        aria-hidden="true"
        // Altura fixa e largura automática: a marca é retrato, e fixar as
        // duas a distorceria.
        className="h-6 w-auto shrink-0"
      />
      VersusPlay
    </span>
  );
}
